import {Component} from "react";
import CampaignsPlatformNavigation from "./DependenciesNewNav";
import CampaignsDefaultNavigation from "./Dependencies";
import NavigationSelector from "./NavigationSelector";
import {shouldDisplay2022Nav as shouldDisplay2022NavPlatform} from '@platform/cj-platform-navigation';

class App extends Component {
    render() {
        return <NavigationSelector
            CampaignsDefaultNavigationWrapper={CampaignsDefaultNavigation}
            CampaignsPlatformNavigationWrapper={CampaignsPlatformNavigation}
            showCjPlatformNav={shouldDisplay2022NavPlatform}
        />;
    }
}

export default App;